/**
 * Auto select nearest size when unavailable. Retain size when manually selected by user.
  */
(function() {
  'use strict';

  // Track manually size selection
  let userSelectedSize = false;

  // Listen for manual clicks on size options (second fieldset)
  document.addEventListener('click', function(event) {
    const variantPicker = event.target.closest('variant-picker');
    if (!variantPicker) return;

    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length < 2) return;

    const sizeFieldset = fieldsets[1];
    const clickedInput = event.target.closest('input[data-option-name]')
                      || event.target.closest('label')?.querySelector('input[data-option-name]');

    if (clickedInput && sizeFieldset.contains(clickedInput)) {
      userSelectedSize = true;
    }
  });

  document.addEventListener('variant:change', function(event) {
    const { variant } = event.detail;
    if (!variant || variant.available) return;

    // Skip auto-select if user has manually chosen a size
    if (userSelectedSize) return;

    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    setTimeout(() => doAutoSelect(form.getAttribute('id')), 100);
  });

  function doAutoSelect(formId) {
    const variantPicker = document.querySelector(`variant-picker[form-id="${formId}"]`)
                       || document.querySelector('variant-picker');
    if (!variantPicker) return;

    const allVariantsScript = variantPicker.querySelector('script[data-all-variants]');
    if (!allVariantsScript) return;

    const allVariants = JSON.parse(allVariantsScript.textContent || '[]');
    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length < 2) return;

    const colorFieldset = fieldsets[0];
    const sizeFieldset = fieldsets[1];

    const selectedColorInput = colorFieldset.querySelector('input:checked');
    const selectedSizeInput = sizeFieldset.querySelector('input:checked');
    if (!selectedColorInput || !selectedSizeInput) return;

    const currentColor = selectedColorInput.getAttribute('data-option-name');
    const currentSize = selectedSizeInput.getAttribute('data-option-name');

    // Get all sizes in order from the DOM
    const allSizeInputs = Array.from(sizeFieldset.querySelectorAll('input[data-option-name]'));
    const allSizes = allSizeInputs.map(input => input.getAttribute('data-option-name'));
    const currentSizeIndex = allSizes.indexOf(currentSize);

    // Find available sizes for this color
    const availableSizes = allVariants
      .filter(v => v.available && v.option1 === currentColor)
      .map(v => v.option2);

    if (availableSizes.length === 0) return;

    // Find nearest available size
    const nearestSize = findNearestSize(allSizes, currentSizeIndex, availableSizes);
    if (!nearestSize || nearestSize === currentSize) return;

    // Select the nearest size
    const sizeInput = sizeFieldset.querySelector(`input[data-option-name="${nearestSize}"]`);
    if (sizeInput && !sizeInput.checked) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function findNearestSize(allSizes, currentIndex, availableSizes) {
    // Search outward from current index to find nearest available
    for (let distance = 1; distance < allSizes.length; distance++) {
      // Check smaller size first (e.g., if on L, check M before XL)
      const smaller = currentIndex - distance;
      if (smaller >= 0 && availableSizes.includes(allSizes[smaller])) {
        return allSizes[smaller];
      }
      // Then check larger size
      const larger = currentIndex + distance;
      if (larger < allSizes.length && availableSizes.includes(allSizes[larger])) {
        return allSizes[larger];
      }
    }
    // Fallback to first available
    return availableSizes[0];
  }
})();
